import { apiGet } from "./BaseService";

export interface SiteStats {
  totalStates: number;
  totalGroups: number;
  totalPrograms: number;
  totalSchedules: number;
}

export const fetchSiteStats = async (): Promise<SiteStats> => {
  try {
    return await apiGet('/stats/site');
  } catch (error) {
    console.error("Error fetching site stats:", error);
    // Return default values if API fails
    return {
      totalStates: 0,
      totalGroups: 0,
      totalPrograms: 0,
      totalSchedules: 0
    };
  }
};